// import React, { useState, useEffect } from "react";
// import {
//   Box,
//   TableContainer,
//   Paper,
//   Table,
//   TableHead,
//   TableRow,
//   TableCell,
//   TableBody,
//   TextField,
//   IconButton,
//   Button,
//   useMediaQuery,
//   useTheme,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Typography,
//   Grid,
//   Card,
//   CardContent,
//   TablePagination
// } from "@mui/material";
// import { 
//   Add, 
//   Save, 
//   Cancel, 
//   Edit, 
//   Delete, 
//   Visibility,
//   Close 
// } from "@mui/icons-material";
// import axios from "axios";

// const Familypagedata = () => {
//   const [members, setMembers] = useState([]);
//   const [newMember, setNewMember] = useState({
//     name: "",
//     relationship: "",
//     age: "",
//     dateOfBirth: "",
//     phoneNumber: "",
//     pincode: "",
//     address: ""
//   });
//   const [editingId, setEditingId] = useState(null);
//   const [showAddRow, setShowAddRow] = useState(false);
//   const [viewDialogOpen, setViewDialogOpen] = useState(false);
//   const [selectedMember, setSelectedMember] = useState(null);
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(10);
  
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
//   const isTablet = useMediaQuery(theme.breakpoints.down('md'));

//   const handleNewMemberChange = (field, value) => {
//     setNewMember(prev => ({ ...prev, [field]: value }));
//   };

//   const handleAddNew = async () => {
//     if (newMember.name && newMember.relationship) {
//       try {
//         const response = await axios.post("http://10.10.222.56:8283/family/AddFamily", newMember);
        
//         if (response.data.success) {
//           setMembers([{ ...newMember, id: Date.now() }, ...members]);
//           setNewMember({
//             name: "",
//             relationship: "",
//             age: "",
//             dateOfBirth: "",
//             phoneNumber: "",
//             pincode: "",
//             address: ""
//           });
//           setShowAddRow(false);
//           alert("Family member added successfully!");
//         } else {
//           console.error("Failed to add family member:", response.data.message);
//           alert("Failed to add family member. Please try again.");
//         }
//       } catch (error) {
//         console.error("Error adding family member:", error);
//         alert("Error adding family member. Please check your connection.");
//       }
//     } else {
//       alert("Name and Relationship are required fields!");
//     }
//   };

//   const handleEdit = (id) => {
//     setEditingId(id);
//   };

//   const handleMemberChange = (id, field, value) => {
//     setMembers(prev =>
//       prev.map(member =>
//         member.id === id ? { ...member, [field]: value } : member
//       )
//     );
//   };

//   const handleSave = async (id) => {
//     const memberToUpdate = members.find(member => member.id === id);
//     if (memberToUpdate) {
//       try {
//         const response = await axios.put(`http://10.10.222.56:8283/family/UpdateFamily/${id}`, memberToUpdate);
        
//         if (response.data.success) {
//           setEditingId(null);
//           alert("Family member updated successfully!");
//         } else {
//           console.error("Failed to update family member:", response.data.message);
//           alert("Failed to update family member.");
//         }
//       } catch (error) {
//         console.error("Error updating family member:", error);
//         alert("Error updating family member.");
//       }
//     }
//   };

//   const handleCancel = () => {
//     setEditingId(null);
//   };

//   const handleDelete = async (id) => {
//     if (window.confirm("Are you sure you want to delete this family member?")) {
//       try {
//         const response = await axios.delete(`http://10.10.222.56:8283/family/DeleteFamily/${id}`);
        
//         if (response.data.success) {
//           setMembers(prev => prev.filter(member => member.id !== id));
//           alert("Family member deleted successfully!");
//         } else {
//           console.error("Failed to delete family member:", response.data.message);
//           alert("Failed to delete family member.");
//         }
//       } catch (error) {
//         console.error("Error deleting family member:", error);
//         alert("Error deleting family member.");
//       }
//     }
//   };

//   const handleView = (member) => {
//     setSelectedMember(member);
//     setViewDialogOpen(true);
//   };

//   const handleChangePage = (event, newPage) => {
//     setPage(newPage);
//   };

//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0);
//   };

//   useEffect(() => {
//     const fetchFamilyMembers = async () => {
//       try {
//         const response = await axios.get("http://10.10.222.56:8283/family/GetFamilyMembers/1");
//         if (response.data.success) {
//           setMembers(response.data.data);
//         }
//       } catch (error) {
//         console.error("Error fetching family members:", error);
//         alert("Error fetching family members. Please check your connection.");
//       }
//     };
    
//     fetchFamilyMembers();
//   }, []);

//   // Responsive table header
//   const tableHeaders = isMobile ? 
//     ["S.NO", "Name", "Relationship", "Actions"] :
//     ["S.NO", "Name", "Relationship", "Age", "Date Of Birth", "Phone Number", "Pin Code", "Address", "Actions"];

//   // Mobile View - Card layout
//   if (isMobile) {
//     return (
//       <Box>
//         <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
//           <Typography variant="h6" component="h2">
//             Family Members
//           </Typography>
//           <Button 
//             variant="contained" 
//             startIcon={<Add />}
//             onClick={() => setShowAddRow(true)}
//             size="small"
//           >
//             Add Member
//           </Button>
//         </Box>

//         {showAddRow && (
//           <Card sx={{ mb: 2, bgcolor: '#f5f5f5' }}>
//             <CardContent>
//               <Typography variant="subtitle1" gutterBottom>
//                 Add New Member
//               </Typography>
//               <Grid container spacing={1}>
//                 <Grid item xs={12} sm={6}>
//                   <TextField
//                     fullWidth
//                     label="Name"
//                     size="small"
//                     value={newMember.name}
//                     onChange={(e) => handleNewMemberChange("name", e.target.value)}
//                     required
//                   />
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <TextField
//                     fullWidth
//                     label="Relationship"
//                     size="small"
//                     value={newMember.relationship}
//                     onChange={(e) => handleNewMemberChange("relationship", e.target.value)}
//                     required
//                   />
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <TextField
//                     fullWidth
//                     label="Age"
//                     size="small"
//                     value={newMember.age}
//                     onChange={(e) => handleNewMemberChange("age", e.target.value)}
//                   />
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <TextField
//                     fullWidth
//                     label="Date of Birth"
//                     type="date"
//                     size="small"
//                     value={newMember.dateOfBirth}
//                     onChange={(e) => handleNewMemberChange("dateOfBirth", e.target.value)}
//                     InputLabelProps={{ shrink: true }}
//                   />
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <TextField
//                     fullWidth
//                     label="Phone Number"
//                     size="small"
//                     value={newMember.phoneNumber}
//                     onChange={(e) => handleNewMemberChange("phoneNumber", e.target.value)}
//                   />
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <TextField
//                     fullWidth
//                     label="Pincode"
//                     size="small"
//                     value={newMember.pincode}
//                     onChange={(e) => handleNewMemberChange("pincode", e.target.value)}
//                   />
//                 </Grid>
//                 <Grid item xs={12}>
//                   <TextField
//                     fullWidth
//                     label="Address"
//                     multiline
//                     rows={2}
//                     size="small"
//                     value={newMember.address}
//                     onChange={(e) => handleNewMemberChange("address", e.target.value)}
//                   />
//                 </Grid>
//                 <Grid item xs={12}>
//                   <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end' }}>
//                     <Button 
//                       variant="contained" 
//                       onClick={handleAddNew}
//                       disabled={!newMember.name || !newMember.relationship}
//                       size="small"
//                       startIcon={<Save />}
//                     >
//                       Save
//                     </Button>
//                     <Button 
//                       variant="outlined" 
//                       onClick={() => setShowAddRow(false)}
//                       size="small"
//                       startIcon={<Close />}
//                     >
//                       Cancel
//                     </Button>
//                   </Box>
//                 </Grid>
//               </Grid>
//             </CardContent>
//           </Card>
//         )}

//         {members.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((member, index) => (
//           <Card key={member.id} sx={{ mb: 1 }}>
//             <CardContent>
//               <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1 }}>
//                 <Box>
//                   <Typography variant="subtitle1" fontWeight="bold">
//                     {member.name}
//                   </Typography>
//                   <Typography variant="body2" color="text.secondary">
//                     {member.relationship}
//                   </Typography>
//                 </Box>
//                 <Typography variant="body2" color="text.secondary">
//                   {page * rowsPerPage + index + 1}
//                 </Typography>
//               </Box>
              
//               <Grid container spacing={0.5}>
//                 <Grid item xs={6}>
//                   <Typography variant="body2">
//                     <strong>Age:</strong> {member.age}
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={6}>
//                   <Typography variant="body2">
//                     <strong>DOB:</strong> {member.dateOfBirth}
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12}>
//                   <Typography variant="body2">
//                     <strong>Phone:</strong> {member.phoneNumber}
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12}>
//                   <Typography variant="body2" noWrap>
//                     <strong>Address:</strong> {member.address}
//                   </Typography>
//                 </Grid>
//               </Grid>
              
//               <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 0.5, mt: 1 }}>
//                 <IconButton size="small" onClick={() => handleView(member)}>
//                   <Visibility fontSize="small" />
//                 </IconButton>
//                 <IconButton size="small" onClick={() => handleEdit(member.id)}>
//                   <Edit fontSize="small" />
//                 </IconButton>
//                 <IconButton size="small" onClick={() => handleDelete(member.id)}>
//                   <Delete fontSize="small" />
//                 </IconButton>
//               </Box>
//             </CardContent>
//           </Card>
//         ))}

//         <TablePagination
//           component="div"
//           count={members.length}
//           page={page}
//           onPageChange={handleChangePage}
//           rowsPerPage={rowsPerPage}
//           onRowsPerPageChange={handleChangeRowsPerPage}
//         />

//         {/* View Dialog for Mobile */}
//         <Dialog open={viewDialogOpen} onClose={() => setViewDialogOpen(false)} fullWidth maxWidth="sm">
//           <DialogTitle>Member Details</DialogTitle>
//           <DialogContent>
//             {selectedMember && (
//               <Grid container spacing={2}>
//                 <Grid item xs={12}>
//                   <Typography><strong>Name:</strong> {selectedMember.name}</Typography>
//                 </Grid>
//                 <Grid item xs={12}>
//                   <Typography><strong>Relationship:</strong> {selectedMember.relationship}</Typography>
//                 </Grid>
//                 <Grid item xs={6}>
//                   <Typography><strong>Age:</strong> {selectedMember.age}</Typography>
//                 </Grid>
//                 <Grid item xs={6}>
//                   <Typography><strong>DOB:</strong> {selectedMember.dateOfBirth}</Typography>
//                 </Grid>
//                 <Grid item xs={12}>
//                   <Typography><strong>Phone:</strong> {selectedMember.phoneNumber}</Typography>
//                 </Grid>
//                 <Grid item xs={12}>
//                   <Typography><strong>Pincode:</strong> {selectedMember.pincode}</Typography>
//                 </Grid>
//                 <Grid item xs={12}>
//                   <Typography><strong>Address:</strong> {selectedMember.address}</Typography>
//                 </Grid>
//               </Grid>
//             )}
//           </DialogContent>
//           <DialogActions>
//             <Button onClick={() => setViewDialogOpen(false)}>Close</Button>
//           </DialogActions>
//         </Dialog>
//       </Box>
//     );
//   }

//   // Tablet and Desktop View
//   return (
//     <Box>
//       <Box sx={{ 
//         display: 'flex', 
//         justifyContent: 'space-between', 
//         alignItems: 'center', 
//         mb: 2,
//         flexDirection: { xs: 'column', sm: 'row' },
//         gap: { xs: 1, sm: 0 }
//       }}>
//         <Typography variant="h5" component="h1">
//           Family Members
//         </Typography>
//         <Button 
//           variant="contained" 
//           startIcon={<Add />}
//           onClick={() => setShowAddRow(true)}
//           sx={{ minWidth: { xs: '100%', sm: 'auto' } }}
//         >
//           Add New Member
//         </Button>
//       </Box>

//       <Paper sx={{ width: '100%', overflow: 'hidden' }}>
//         <TableContainer sx={{ maxHeight: 400 }}>
//           <Table stickyHeader size={isTablet ? "small" : "medium"}>
//             <TableHead>
//               <TableRow>
//                 {tableHeaders.map((header, index) => (
//                   <TableCell
//                     key={index}
//                     align="center"
//                     sx={{
//                       fontWeight: "bold",
//                       backgroundColor: theme.palette.primary.light,
//                       color: theme.palette.primary.contrastText,
//                       whiteSpace: 'nowrap',
//                       padding: '8px'
//                     }}
//                   >
//                     {header}
//                   </TableCell>
//                 ))}
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {showAddRow && (
//                 <TableRow sx={{ bgcolor: '#f9f9f9' }}>
//                   <TableCell align="center" sx={{ padding: '8px' }}>-</TableCell>
//                   <TableCell align="center" sx={{ padding: '8px' }}>
//                     <TextField
//                       size="small"
//                       fullWidth
//                       value={newMember.name}
//                       onChange={(e) => handleNewMemberChange("name", e.target.value)}
//                       required
//                     />
//                   </TableCell>
//                   <TableCell align="center" sx={{ padding: '8px' }}>
//                     <TextField
//                       size="small"
//                       fullWidth
//                       value={newMember.relationship}
//                       onChange={(e) => handleNewMemberChange("relationship", e.target.value)}
//                       required
//                     />
//                   </TableCell>
//                   {!isMobile && (
//                     <>
//                       <TableCell align="center" sx={{ padding: '8px' }}>
//                         <TextField
//                           size="small"
//                           fullWidth
//                           value={newMember.age}
//                           onChange={(e) => handleNewMemberChange("age", e.target.value)}
//                         />
//                       </TableCell>
//                       <TableCell align="center" sx={{ padding: '8px' }}>
//                         <TextField
//                           size="small"
//                           type="date"
//                           fullWidth
//                           value={newMember.dateOfBirth}
//                           onChange={(e) => handleNewMemberChange("dateOfBirth", e.target.value)}
//                           InputLabelProps={{ shrink: true }}
//                         />
//                       </TableCell>
//                       <TableCell align="center" sx={{ padding: '8px' }}>
//                         <TextField
//                           size="small"
//                           fullWidth
//                           value={newMember.phoneNumber}
//                           onChange={(e) => handleNewMemberChange("phoneNumber", e.target.value)}
//                         />
//                       </TableCell>
//                       <TableCell align="center" sx={{ padding: '8px' }}>
//                         <TextField
//                           size="small"
//                           fullWidth
//                           value={newMember.pincode}
//                           onChange={(e) => handleNewMemberChange("pincode", e.target.value)}
//                         />
//                       </TableCell>
//                       <TableCell align="center" sx={{ padding: '8px' }}>
//                         <TextField
//                           size="small"
//                           fullWidth
//                           value={newMember.address}
//                           onChange={(e) => handleNewMemberChange("address", e.target.value)}
//                         />
//                       </TableCell>
//                     </>
//                   )}
//                   <TableCell align="center" sx={{ padding: '8px' }}>
//                     <Box sx={{ display: 'flex', justifyContent: 'center', gap: 0.5 }}>
//                       <IconButton 
//                         onClick={handleAddNew}
//                         disabled={!newMember.name || !newMember.relationship}
//                         color="primary"
//                         size="small"
//                       >
//                         <Save />
//                       </IconButton>
//                       <IconButton 
//                         onClick={() => setShowAddRow(false)}
//                         color="error"
//                         size="small"
//                       >
//                         <Cancel />
//                       </IconButton>
//                     </Box>
//                   </TableCell>
//                 </TableRow>
//               )}

//               {members.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((member, index) => (
//                 <TableRow key={member.id}>
//                   <TableCell align="center" sx={{ padding: '8px' }}>{page * rowsPerPage + index + 1}</TableCell>
//                   <TableCell align="center" sx={{ padding: '8px' }}>
//                     {editingId === member.id ? (
//                       <TextField
//                         size="small"
//                         fullWidth
//                         value={member.name}
//                         onChange={(e) => handleMemberChange(member.id, "name", e.target.value)}
//                       />
//                     ) : (
//                       member.name
//                     )}
//                   </TableCell>
//                   <TableCell align="center" sx={{ padding: '8px' }}>
//                     {editingId === member.id ? (
//                       <TextField
//                         size="small"
//                         fullWidth
//                         value={member.relationship}
//                         onChange={(e) => handleMemberChange(member.id, "relationship", e.target.value)}
//                       />
//                     ) : (
//                       member.relationship
//                     )}
//                   </TableCell>
//                   {!isMobile && (
//                     <>
//                       <TableCell align="center" sx={{ padding: '8px' }}>
//                         {editingId === member.id ? (
//                           <TextField
//                             size="small"
//                             fullWidth
//                             value={member.age}
//                             onChange={(e) => handleMemberChange(member.id, "age", e.target.value)}
//                           />
//                         ) : (
//                           member.age
//                         )}
//                       </TableCell>
//                       <TableCell align="center" sx={{ padding: '8px' }}>
//                         {editingId === member.id ? (
//                           <TextField
//                             size="small"
//                             type="date"
//                             fullWidth
//                             value={member.dateOfBirth}
//                             onChange={(e) => handleMemberChange(member.id, "dateOfBirth", e.target.value)}
//                             InputLabelProps={{ shrink: true }}
//                           />
//                         ) : (
//                           member.dateOfBirth
//                         )}
//                       </TableCell>
//                       <TableCell align="center" sx={{ padding: '8px' }}>
//                         {editingId === member.id ? (
//                           <TextField
//                             size="small"
//                             fullWidth
//                             value={member.phoneNumber}
//                             onChange={(e) => handleMemberChange(member.id, "phoneNumber", e.target.value)}
//                           />
//                         ) : (
//                           member.phoneNumber
//                         )}
//                       </TableCell>
//                       <TableCell align="center" sx={{ padding: '8px' }}>
//                         {editingId === member.id ? (
//                           <TextField
//                             size="small"
//                             fullWidth
//                             value={member.pincode}
//                             onChange={(e) => handleMemberChange(member.id, "pincode", e.target.value)}
//                           />
//                         ) : (
//                           member.pincode
//                         )}
//                       </TableCell>
//                       <TableCell align="center" sx={{ padding: '8px' }}>
//                         {editingId === member.id ? (
//                           <TextField
//                             size="small"
//                             fullWidth
//                             value={member.address}
//                             onChange={(e) => handleMemberChange(member.id, "address", e.target.value)}
//                           />
//                         ) : (
//                           <Typography variant="body2" sx={{ maxWidth: '150px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
//                             {member.address}
//                           </Typography>
//                         )}
//                       </TableCell>
//                     </>
//                   )}
//                   <TableCell align="center" sx={{ padding: '8px' }}>
//                     <Box sx={{ display: 'flex', justifyContent: 'center', gap: 0.5 }}>
//                       {editingId === member.id ? (
//                         <>
//                           <IconButton onClick={() => handleSave(member.id)} size="small">
//                             <Save color="primary" />
//                           </IconButton>
//                           <IconButton onClick={handleCancel} size="small">
//                             <Cancel color="error" />
//                           </IconButton>
//                         </>
//                       ) : (
//                         <>
//                           <IconButton onClick={() => handleView(member)} size="small">
//                             <Visibility color="info" />
//                           </IconButton>
//                           <IconButton onClick={() => handleEdit(member.id)} size="small">
//                             <Edit color="primary" />
//                           </IconButton>
//                           <IconButton onClick={() => handleDelete(member.id)} size="small">
//                             <Delete color="error" />
//                           </IconButton>
//                         </>
//                       )}
//                     </Box>
//                   </TableCell>
//                 </TableRow>
//               ))}
//             </TableBody>
//           </Table>
//         </TableContainer>
//         <TablePagination
//           rowsPerPageOptions={[5, 10, 25, 50]}
//           component="div"
//           count={members.length}
//           page={page}
//           onPageChange={handleChangePage}
//           rowsPerPage={rowsPerPage}
//           onRowsPerPageChange={handleChangeRowsPerPage}
//         />
//       </Paper>

//       {/* View Dialog for Tablet/Desktop */}
//       <Dialog open={viewDialogOpen} onClose={() => setViewDialogOpen(false)} maxWidth="md" fullWidth>
//         <DialogTitle>Family Member Details</DialogTitle>
//         <DialogContent>
//           {selectedMember && (
//             <Grid container spacing={2}>
//               <Grid item xs={12} md={6}>
//                 <Typography variant="subtitle1"><strong>Name:</strong> {selectedMember.name}</Typography>
//               </Grid>
//               <Grid item xs={12} md={6}>
//                 <Typography variant="subtitle1"><strong>Relationship:</strong> {selectedMember.relationship}</Typography>
//               </Grid>
//               <Grid item xs={12} md={6}>
//                 <Typography variant="subtitle1"><strong>Age:</strong> {selectedMember.age}</Typography>
//               </Grid>
//               <Grid item xs={12} md={6}>
//                 <Typography variant="subtitle1"><strong>Date of Birth:</strong> {selectedMember.dateOfBirth}</Typography>
//               </Grid>
//               <Grid item xs={12} md={6}>
//                 <Typography variant="subtitle1"><strong>Phone Number:</strong> {selectedMember.phoneNumber}</Typography>
//               </Grid>
//               <Grid item xs={12} md={6}>
//                 <Typography variant="subtitle1"><strong>Pincode:</strong> {selectedMember.pincode}</Typography>
//               </Grid>
//               <Grid item xs={12}>
//                 <Typography variant="subtitle1"><strong>Address:</strong></Typography>
//                 <Typography variant="body1">{selectedMember.address}</Typography>
//               </Grid>
//             </Grid>
//           )}
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setViewDialogOpen(false)} variant="contained">
//             Close
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </Box>
//   );
// };

// export default Familypagedata;



import React, { useState } from "react";
import {
  Box,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Grid,
  Card,
  CardContent,
  Typography,
  useTheme,
  useMediaQuery
} from "@mui/material";

import { Add, Delete, Visibility, Close, Save } from "@mui/icons-material";
import "./Family.css";

/* ===== DUMMY DATA ===== */
const initialMembers = [
  {
    id: 1,
    name: "Rajesh Kumar",
    relationship: "Father",
    age: 55,
    dateOfBirth: "1969-04-12",
    phoneNumber: "9876543210",
    pincode: "500081",
    address: "Hyderabad, Telangana"
  },
  {
    id: 2,
    name: "Sunita Kumar",
    relationship: "Mother",
    age: 50,
    dateOfBirth: "1974-07-22",
    phoneNumber: "9876501234",
    pincode: "411014",
    address: "Pune, Maharashtra"
  }
];

const emptyMember = {
  name: "",
  relationship: "",
  age: "",
  dateOfBirth: "",
  phoneNumber: "",
  pincode: "",
  address: ""
};

const Familypagedata = () => {
  const [members, setMembers] = useState(initialMembers);
  const [addOpen, setAddOpen] = useState(false);
  const [viewOpen, setViewOpen] = useState(false);
  const [selectedMember, setSelectedMember] = useState(null);
  const [newMember, setNewMember] = useState(emptyMember);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  /* ===== SAVE MEMBER (FIXED) ===== */
  const handleSave = () => {
    if (!newMember.name || !newMember.relationship) return;

    setMembers(prev => [
      { ...newMember, id: Date.now() },
      ...prev
    ]);

    setNewMember(emptyMember);
    setAddOpen(false);
  };

  const handleDelete = (id) => {
    if (window.confirm("Delete member?")) {
      setMembers(prev => prev.filter(m => m.id !== id));
    }
  };

  /* ================= MOBILE VIEW ================= */
  if (isMobile) {
    return (
      <Box className="family-wrapper">
        <div className="family-header">
          <h2>Family Members</h2>
          <Button variant="contained" onClick={() => setAddOpen(true)}>
            Add
          </Button>
        </div>

        {members.map(m => (
          <Card key={m.id} className="family-card">
            <CardContent>
              <Typography variant="h6">{m.name}</Typography>
              <Typography>{m.relationship}</Typography>
              <Typography><b>Phone:</b> {m.phoneNumber}</Typography>

              <div className="card-actions">
                <IconButton onClick={() => { setSelectedMember(m); setViewOpen(true); }}>
                  <Visibility />
                </IconButton>
                <IconButton onClick={() => handleDelete(m.id)}>
                  <Delete />
                </IconButton>
              </div>
            </CardContent>
          </Card>
        ))}

        {/* ADD POPUP (MOBILE WORKING) */}
        <Dialog open={addOpen} onClose={() => setAddOpen(false)} fullScreen>
          <DialogTitle>
            Add Member
            <IconButton onClick={() => setAddOpen(false)} className="close-btn">
              <Close />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            {Object.keys(emptyMember).map(k => (
              <TextField
                key={k}
                label={k}
                fullWidth
                margin="dense"
                value={newMember[k]}
                onChange={e => setNewMember({ ...newMember, [k]: e.target.value })}
              />
            ))}
          </DialogContent>
          <DialogActions>
            <Button onClick={handleSave} variant="contained" startIcon={<Save />}>
              Save
            </Button>
          </DialogActions>
        </Dialog>

        {/* VIEW POPUP */}
        <Dialog open={viewOpen} onClose={() => setViewOpen(false)} fullScreen>
          <DialogTitle>Details</DialogTitle>
          <DialogContent>
            {selectedMember &&
              Object.entries(selectedMember).map(([k, v]) => (
                <p key={k}><b>{k}:</b> {v}</p>
              ))}
          </DialogContent>
        </Dialog>
      </Box>
    );
  }

  /* ================= DESKTOP / TABLET ================= */
  return (
    <Box className="family-wrapper">
      <div className="family-header">
        <h2>Family Members</h2>
        <Button variant="contained" startIcon={<Add />} onClick={() => setAddOpen(true)}>
          Add Member
        </Button>
      </div>

      <Paper className="family-table-box">
        <Table size="small">
          <TableHead>
            <TableRow>
              {["Name", "Relation", "Age", "DOB", "Phone", "Pincode", "Address", "Action"]
                .map(h => <TableCell key={h} align="center">{h}</TableCell>)}
            </TableRow>
          </TableHead>
          <TableBody>
            {members.map(m => (
              <TableRow key={m.id}>
                <TableCell align="center">{m.name}</TableCell>
                <TableCell align="center">{m.relationship}</TableCell>
                <TableCell align="center">{m.age}</TableCell>
                <TableCell align="center">{m.dateOfBirth}</TableCell>
                <TableCell align="center">{m.phoneNumber}</TableCell>
                <TableCell align="center">{m.pincode}</TableCell>
                <TableCell className="ellipsis">{m.address}</TableCell>
                <TableCell align="center">
                  <IconButton onClick={() => { setSelectedMember(m); setViewOpen(true); }}>
                    <Visibility />
                  </IconButton>
                  <IconButton onClick={() => handleDelete(m.id)}>
                    <Delete />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>

      {/* ADD POPUP */}
      <Dialog open={addOpen} onClose={() => setAddOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Add Family Member</DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            {Object.keys(emptyMember).map(k => (
              <Grid item xs={12} sm={6} key={k}>
                <TextField
                  label={k}
                  fullWidth
                  size="small"
                  value={newMember[k]}
                  onChange={e => setNewMember({ ...newMember, [k]: e.target.value })}
                />
              </Grid>
            ))}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleSave} variant="contained">
            Save
          </Button>
        </DialogActions>
      </Dialog>

      {/* VIEW */}
      <Dialog open={viewOpen} onClose={() => setViewOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Member Details</DialogTitle>
        <DialogContent>
          {selectedMember &&
            Object.entries(selectedMember).map(([k, v]) => (
              <p key={k}><b>{k}:</b> {v}</p>
            ))}
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default Familypagedata;
